import { useMutation } from '@tanstack/react-query';

import { useToast } from '@paid-ui/ui/toast';
import { request } from '@paid-ui/utils/axios';

export const useSendOneTimeCodeToEmail = () => {
  const toast = useToast();

  return useMutation({
    mutationKey: ['SendOneTimeCodeToEmail'],
    mutationFn: async (values: { account: string }) => {
      const { data } = await request.post<null>(
        '/validate/send-confirmation-email-with-code',
        values,
      );
      return data;
    },
    onSuccess: () => {
      toast.success('One time code has been sent.');
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to send one time code.');
    },
  });
};

export const useSendOneTimeCodeToMobile = () => {
  const toast = useToast();

  return useMutation({
    mutationKey: ['SendOneTimeCodeToMobile'],
    mutationFn: async () => {
      await request.post<null>('/users/mobile/code/send');
      return null;
    },
    onSuccess: () => {
      toast.success('One time code has been sent.');
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to send one time code.');
    },
  });
};
